const getTime = () => {
  const date = new Date()
  const hours = date.getHours()
  const minutes = date.getMinutes()
  const seconds = date.getSeconds()
  return `${hours}${minutes < 10 ? ':0' : ':'}${minutes}${seconds < 10 ? ':0' : ':'}${seconds}`
}

const introduction = [
  `Welcome to Jarvis Gao homepage v0.1.0.`,
  {
    type: 'system',
    label: 'System',
    content: `cd /jarvisgao`
  },
  {
    type: 'system',
    label: 'System',
    content: '😺 Thanks for your visit, let me briefly introduce myself: '
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Name:',
    content: 'Yuanjian(Jarvis) Gao'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Email:',
    content: 'jarvisg495@gmail.com'
  },
  {
    time: getTime(),
    type: 'info',
    label: 'Who Am I:',
    content: ' Recent Computer Science Master\'s graduate from Manning College of Information and Computer Sciences, UMass Amherst'
  }
]

export default {
  intro: {
    description: 'Introducting myself again.',
    run(print) {
      let i = 0
      return new Promise(resolve => {
        const interval = setInterval(() => {
          print(introduction[i])
          i++
          if (!introduction[i]) {
            clearInterval(interval)
            resolve({ type: 'success', label: 'Done', content: 'Intro is over!' })
          }
        }, 500)
      })
    }
  },
  echo: {
    description: 'Echoes input.',
    run(print, input) {
      return new Promise(resolve => {
        print({
          time: getTime(),
          label: '',
          type: 'success',
          content: input
        })
        resolve({ type: 'success', label: '', content: '' })
      })
    }
  },
  open: {
    description: 'Open a specified url in a new tab.',
    run(print, input) {
      return new Promise((resolve) => {
        if (!input) {
          resolve({ type: 'error', label: 'Error', content: 'a url is required!' })
          return
        }
        if (!input.startsWith('http')) {
          resolve({ type: 'error', label: 'Error', content: 'Please add `http` prefix!' })
          return
        }
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open(input, '_blank')
        resolve({ type: 'success', label: 'Done', content: 'Page Opened!' })
      })
    }
  },
  linkedin: {
    description: 'Open my linkedin in a new tab.',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening' })

        window.open('https://www.linkedin.com/in/yuanjiangao/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':D' })
      })
    }
  },
  resume: {
    description: 'Open my resume in a new tab (linkedin page for now; to be updated)',
    run(print) {
      return new Promise((resolve) => {
        print({ type: 'success', label: 'Success', content: 'Opening Linkedin Page instead...' })

        window.open('https://www.linkedin.com/in/yuanjiangao/', '_blank')
        resolve({ type: 'success', label: 'Done', content: ':)' })
      })
    }
  }
}
